module.exports = __webpack_public_path__ + "img/fws-icon.aa7a4cf9.png";